module.exports = __webpack_public_path__ + "img/Image.da130e2a.jpg";